import React from 'react';
import { useMediaBreakpoint } from '@americanexpress/consumer-travel-base';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { clsx } from 'clsx';
import PropTypes from 'prop-types';
import { formatDate } from '../../../utils/abandonCartUtils';
import { useAbandonCartData } from '../../../hooks/useContextApiHook';
import { clearContextThunk } from '../../../thunks/clearContextThunk';

const DismissButton = ({ triggerAnalytics }) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const isDesktop = useMediaBreakpoint('lg-up');

  const {
    data: abandonCartData,
    run: reRunContextApi,
  } = useAbandonCartData();
  const {
    tripStartDate,
    tripEndDate,
    hotelProductSelected,
  } = abandonCartData;
  return (
    <button
      id="abandonHotelDismissButton"
      className={clsx('btn btn-sm',
        isDesktop ? 'btn-tertiary pad-1 flex flex-justify-center text-align-center dls-white dls-deep-blue-bg dls-gray-05-bg-hvr text-underline'
          : 'btn-white-secondary margin-1 width-full'
      )}
      type="button"
      aria-describedby={
        `${formatMessage({ id: 'abandonHotel.finish' })} ${hotelProductSelected} ${formatDate(tripStartDate)} - ${formatDate(tripEndDate)}`
      }
      onClick={(event) => {
        event.stopPropagation();
        dispatch(clearContextThunk({ reRunContextApi }));
        triggerAnalytics('dismiss');
      }}
    >
      {formatMessage({ id: 'abandonHotel.dismiss' })}
    </button>
  );
};

DismissButton.propTypes = {
  triggerAnalytics: PropTypes.func.isRequired,
};

export default DismissButton;
